import { Base } from "@studiometa/js-toolkit";
import { debounce } from "@studiometa/js-toolkit/utils";
import Swiper from "swiper";

export default class SliderCollection extends Base {
  static config = {
    name: 'SliderCollection',
    refs: ['slider', 'wrapper', 'slides[]'],
    log: true,
  };

  slider = null;

  slides = [];

  isHover = false;

  isMoved = false;

  mounted() {
    this.$log('mounted');
    this.initDebounce = debounce(this.init.bind(this), 200);
    this.mobileDebounce = debounce(this.mobile.bind(this), 1000);
    this.viewportWidth = window.innerWidth;
    this.init();
  }

  init() {
    if (!this.$refs.slides.length) {
      this.$destroy();
      return;
    }

    this.speed = 1000 * this.$refs.slides.length * 2;
    this.slider = new Swiper(this.$refs.slider, {
      direction: 'horizontal',
      autoplay: {
        delay: 0,
      },
      slidesPerView: 1,
      speed: this.speed,
      loop: true,
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      allowTouchMove: true,
    });

    const self = this;
    this.slider.on('touchEnd', () => self.onSliderTouchEnd());
    this.slider.on('sliderMove', () => self.onSliderSliderMove());
  }

  stopSlider() {
    if (!this.slider || this.isHover) {
      return;
    }

    this.isHover = true;

    this.slider.autoplay.stop();

    const posX = this.$refs.wrapper.getBoundingClientRect().left;
    this.$refs.wrapper.style.transform = `translate3d(${posX}px, 0px, 0px)`;
    this.slider.params.speed = 300;
    this.slider.params.freeMode = {
      enabled: true,
      sticky: false,
    };
  }

  onMouseenter() {
    this.stopSlider();
  }

  onMouseleave() {
    if (!this.slider || !this.isHover) {
      return;
    }

    this.slider.params.speed = this.speed;
    this.slider.params.freeMode = {
      enabled: false,
      sticky: false,
    };

    this.slider.autoplay.start();

    const prevSlide = this.slider.slides[this.slider.previousIndex];
    const { left, width } = prevSlide.getBoundingClientRect();

    const progress = 1 + ( left / width );
    const newSpeed = this.speed * progress;

    if (newSpeed <= this.speed) {
      this.$refs.wrapper.style.transitionDuration = `${newSpeed}ms`;
    }

    if (!this.isMoved) {
      this.slider.update();
    }

    this.isHover = false;
    this.isMoved = false
  }

  onSliderTouchEnd() {
    this.mobileDebounce();
  }

  onSliderSliderMove() {
    this.isMoved = true;
    this.stopSlider();
  }

  onWindowResize() {
    if (this.viewportWidth === window.innerWidth) {
      return;
    }

    this.viewportWidth = window.innerWidth;

    if (!this.slider) {
      return;
    }

    this.destroySlider();
    this.initDebounce();
  }

  mobile() {
    if (window.innerWidth >= 768) {
      return;
    }

    this.onMouseleave();
  }

  destroySlider () {
    if (!this.slider) {
      return;
    }

    this.slider.destroy();
    this.slider = null;
  }

  destroyed() {
    this.destroySlider();
  }
}
